import { render } from "./TravelSpecialistCard.vue?vue&type=template&id=f55cb1ee"
import script from "./TravelSpecialistCard.vue?vue&type=script&lang=js"
export * from "./TravelSpecialistCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__